import { gql } from '@apollo/client'

export const GET_AI_COACHING_INTERVENTIONS = gql`
  query GetAiCoachingInterventions(
    $userId: Int
    $userEmail: String
    $identifier: String
    $shouldIntervene: Boolean
    $status: [AiCoachingInterventionStatus!]
    $claimedByMe: Boolean
    $unclaimed: Boolean
    $limit: Int
    $offset: Int
  ) {
    aiCoachingInterventions(
      userId: $userId
      userEmail: $userEmail
      identifier: $identifier
      shouldIntervene: $shouldIntervene
      status: $status
      claimedByMe: $claimedByMe
      unclaimed: $unclaimed
      limit: $limit
      offset: $offset
    ) {
      total
      interventions {
        id
        identifier
        version
        trigger
        shouldIntervene
        createdAt
        updatedAt
        message
        editedMessage
        status
        claimedAt
        claimedBy {
          id
          firstName
          lastName
          email
        }
        coachFeedback
        coachRating
        emailedAt
        postedToFeedAt
        declinedAt
        declineReason
        user {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`

export const GET_AI_COACHING_INTERVENTION = gql`
  query GetAiCoachingIntervention($id: Int!) {
    aiCoachingIntervention(id: $id) {
      id
      identifier
      version
      trigger
      shouldIntervene
      createdAt
      updatedAt
      message
      editedMessage
      status
      claimedAt
      claimedBy {
        id
        firstName
        lastName
        email
      }
      coachFeedback
      coachRating
      emailedAt
      postedToFeedAt
      declinedAt
      declineReason
      user {
        id
        firstName
        lastName
        email
        funderOrgs {
          id
          name
          disabled
        }
        nonprofitOrgs {
          id
          name
          disabled
          cohortMemberships {
            id
            startDate
            endDate
            cohort {
              id
              name
            }
          }
        }
      }
    }
  }
`

export const TRIGGER_INTERVENTION = gql`
  mutation TriggerIntervention(
    $identifier: String!
    $userId: Int!
    $force: Boolean
  ) {
    triggerAiCoachingIntervention(
      identifier: $identifier
      userId: $userId
      force: $force
    ) {
      success
      message
      interventionId
    }
  }
`

export const CLAIM_AI_COACHING_INTERVENTION = gql`
  mutation ClaimAiCoachingIntervention($interventionId: Int!) {
    claimAiCoachingIntervention(interventionId: $interventionId) {
      success
      message
      interventionId
    }
  }
`

export const UPDATE_AI_COACHING_INTERVENTION = gql`
  mutation UpdateAiCoachingIntervention(
    $interventionId: Int!
    $editedMessage: String
    $coachFeedback: String
    $coachRating: String
  ) {
    updateAiCoachingIntervention(
      interventionId: $interventionId
      editedMessage: $editedMessage
      coachFeedback: $coachFeedback
      coachRating: $coachRating
    ) {
      success
      message
      interventionId
    }
  }
`

export const SEND_AI_COACHING_EMAIL = gql`
  mutation SendAiCoachingEmail($interventionId: Int!) {
    sendAiCoachingEmail(interventionId: $interventionId) {
      success
      message
      interventionId
    }
  }
`

export const POST_AI_COACHING_TO_FEED = gql`
  mutation PostAiCoachingToFeed($interventionId: Int!) {
    postAiCoachingToFeed(interventionId: $interventionId) {
      success
      message
      interventionId
    }
  }
`

export const DECLINE_AI_COACHING_INTERVENTION = gql`
  mutation DeclineAiCoachingIntervention(
    $interventionId: Int!
    $reason: String
  ) {
    declineAiCoachingIntervention(
      interventionId: $interventionId
      reason: $reason
    ) {
      success
      message
      interventionId
    }
  }
`
